import styled from "styled-components";

export const VoucherCardSideToggleButtonBox = styled.div`
    border: 1px solid;
    border-radius: 50%;
    padding: 1px;
    box-sizing: content-box;
    width: 1.4rem;
    height: 1.4rem;
    cursor: pointer;
`